import React, { useState } from 'react'
import { Link } from 'react-router-dom'


const Button = ({to, label, firstStyle, icon, buttonGroup, outsideWebsite}) => {

    const [mouse,  setMouse] = useState(false)

    const style = {
        fontSize: 'var(--paragraph-fz)',
        fontWeight: firstStyle ? '' : 'var(--regular-fw)',
        textDecoration: 'none',
        padding: '.45em 2em',
        borderRadius: '100px',
        backgroundColor: firstStyle ? 'var(--primary-clr)' : 'transparent',
        color: firstStyle ? 'white' : 'var(--primary-clr)',
        border: '1.6px solid var(--primary-clr)',
        cursor: 'pointer',
        transition: '.25s ease-out' ,
        boxShadow: mouse && 'var(--shadows)', //firstStyle && 
        marginRight: buttonGroup && '.5rem'
    }

    return (
        <Link
            target={outsideWebsite ? '_blank' : ''}
            onMouseEnter={() => setMouse(true)}
            onMouseLeave={() => setMouse(false)}
            style={style}
            to={to}>
            {icon && icon}
            {label}
        </Link>
    )
}

export default Button
